(function () {

  const product_slider_v1_list = document.querySelectorAll('.js_product_slider_v1')

  for (let i = 0; i < product_slider_v1_list.length; i++) {
    const slider = product_slider_v1_list[i]
    initProductSliderV1(slider)
  }

  function initProductSliderV1 (slider) {
    const sliderWrapEl = slider.closest('.product-slider-sec')
    const swiperPagination = sliderWrapEl.querySelector('.swiper-pagination')
    const swiperButtonNext = sliderWrapEl.querySelector('.swiper-button-next')
    const swiperButtonPrev = sliderWrapEl.querySelector('.swiper-button-prev')

    let sliderOptions = {

      spaceBetween: 40,
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        767: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        // when window width is >= 1200px
        1200: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      },
      pagination: {
        el: swiperPagination,
        clickable: true,
        dynamicBullets: false,
      },
      navigation: {
        nextEl: swiperButtonNext,
        prevEl: swiperButtonPrev,
      },
    }

    // Override from theme
    // if (window.productSliderV1Override) {
    //   sliderOptions = window.productSliderV1Override(slider)
    // }

    new Swiper(slider, sliderOptions)
  }

})()
